import React from "react";

const ITEMS = [
  { figure: "360024", caption: "Centro autorizado DGT" },
  { figure: "2018", caption: "Impartiendo cursos de puntos" },
  { figure: "+500", caption: "Alumnos formados" },
  { figure: "7", caption: "Formadores, psicólogas y colaboradores en cada convocatoria" },
];

export default function TrustBarPuntos() {
  return (
    <div
      className="rounded-2xl bg-[var(--faro-bg)] px-6 py-8 sm:px-10 sm:py-10 grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8"
      data-testid="trust-bar"
    >
      {ITEMS.map((it) => (
        <div key={it.figure} className="text-center">
          <div
            className="font-display font-black text-3xl sm:text-4xl leading-none"
            style={{ color: "#161692" }}
          >
            {it.figure}
          </div>
          <div className="mt-2 text-xs sm:text-sm text-[var(--faro-text-soft)] leading-snug">
            {it.caption}
          </div>
        </div>
      ))}
    </div>
  );
}
